import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TableCell } from 'src/app/models/table';

@Component({
  selector: 'app-user-stats-table-header',
  templateUrl: './user-stats-table-header.component.html',
  styleUrls: ['./user-stats-table-header.component.scss'],
})
export class UserStatsTableHeaderComponent implements OnInit {
  @Input() ncells: number;
  @Input() start = 0;
  @Input() icons: string[];
  @Input() labels: string[];
  @Input() slotAlign = 'center';

  cells: TableCell[] = [];
  slotAlignment: boolean[];

  ngOnInit() {
    this.buildCells();
    this.slotAlignment = [this.slotAlign === 'left', this.slotAlign === 'default', this.slotAlign === 'right'];
  }

  // TODO Validate input parameters (icons.length and labels.length can't be longer than ncells - start)

  private buildCells() {
    const iconsOffset = this.ncells - this.icons.length;
    const labelsOffset = this.ncells - this.labels.length;
    for (let i = 0; i < this.ncells; i++) {
      const cell: TableCell = {
        icon: i < iconsOffset ? null : this.icons[i - iconsOffset],
        label: i < labelsOffset ? null : this.labels[i - labelsOffset],
      };
      this.cells.push(cell);
    }
  }
}
